import { graphql } from 'react-relay';

import createMutation from '../relay/createMutation';

const mutation = graphql`
  mutation AdminAcceptJobOfferMutation($input: AdminForceJobCreationInput!) {
    adminAcceptJob(input: $input) {
      clientMutationId
      job {
        acceptedJobOffer {
          jobRequest {
            status
            offers {
              status
            }
          }
          status
        }
      }
    }
  }
`;

export default variables => createMutation(mutation)(variables);



// WEBPACK FOOTER //
// ./src/mutations/AdminAcceptJobOfferMutation.js